import { Link } from "react-router-dom";
import { Layout, theme } from "antd";
import { isUserLoggedIn } from "../../axios_helper.js";
import Seo from "./Seo.js";
import "./NotFoundPage.css";

export default function NotFoundPage() {
  const { token } = theme.useToken();
  const returnPath = isUserLoggedIn() ? "/me/dailyreport" : "/";
  return (
    <>
      <Seo title="Page not found | Age of Companies" description="The requested page could not be found." noIndex />
      <Layout className="not-found-layout" style={{ padding: "16px" }}>
        <Layout.Content style={{ padding: 16, margin: 0, minHeight: 280, background: token.colorBgContainer, borderRadius: token.borderRadiusLG }}>
          <main id="main-content" className="not-found-page" aria-labelledby="not-found-heading" style={{
            "--not-found-text": token.colorText,
            "--not-found-muted": token.colorTextSecondary,
            "--not-found-accent": token.colorPrimary,
            "--not-found-accent-hover": token.colorPrimaryHover,
          }}>
            <section className="not-found-panel">
              <div className="not-found-code" aria-hidden="true">404</div>
              <h1 id="not-found-heading">Page not found</h1>
              <Link className="not-found-return" to={returnPath}>Return to Age of Companies</Link>
            </section>
          </main>
        </Layout.Content>
      </Layout>
    </>
  );
}
